var DEFAULT_PROPERTY = 'minWidth';

// Модификатор устанавливающий минимальную ширину popper такой же как ширина якоря
export var SAME_WIDTH = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  options: {
    property: DEFAULT_PROPERTY
  },
  fn: function fn(_ref) {
    var state = _ref.state,
      options = _ref.options;
    state.styles.popper[options.property || DEFAULT_PROPERTY] = "".concat(state.rects.reference.width, "px");
  },
  effect: function effect(_ref2) {
    var state = _ref2.state,
      options = _ref2.options;
    return function () {
      state.elements.popper.style[options.property || DEFAULT_PROPERTY] = "".concat(state.elements.reference.offsetWidth, "px");
    };
  }
};